import axiosServices from '../utils/axios';
const backendUrl = import.meta.env.VITE_BACKEND_URL;

export const fetchHealthStatus = async () => {
  try {
    const response = await axiosServices.get(`${backendUrl}/health-check`);
    return response.data;
  } catch (error) {
    console.error('Error fetching health status:', error);
    throw error;
  }
};
